import type {
  FetchNextPageOptions,
  InfiniteData,
  UseInfiniteQueryResult,
} from '@tanstack/react-query'
import type {
  JobAdsFormType,
  JobListingItem,
  ListJobListingsSuccess,
} from '../../types/career.types'
import { useGetPublicInstitutionJobAdsInfiniteQuery } from '@front/api/service-career-neo/useGetPublicInstitutionJobAdsInfiniteQuery'

type UseGetJobOffersListData = {
  fetchNextPage: (
    options?: FetchNextPageOptions,
  ) => Promise<
    UseInfiniteQueryResult<InfiniteData<ListJobListingsSuccess>, Error>
  >
  hasNextPage: boolean
  isError: boolean
  isFetchingNextPage: boolean
  isLoading: boolean
  jobOffersList: JobListingItem[]
  refetch: () => Promise<unknown>
  total?: number
}

export const useGetJobAds = (
  institutionId: string,
  filters: JobAdsFormType | null,
): UseGetJobOffersListData => {
  const {
    data,
    isError,
    isLoading,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
    refetch,
  } = useGetPublicInstitutionJobAdsInfiniteQuery(
    institutionId,
    filters?.departmentCodeQuery,
    filters?.searchQuery,
    filters?.sortBy,
    filters?.sortOrder,
    filters?.contractType?.join(','),
    filters?.contractDuration?.join(','),
    filters?.yearsOfExperience,
    filters?.context,
  )

  const total = data?.pages?.[0]?.pagination?.total
  const jobOffersList = (
    total
      ? data.pages
          ?.map((resultsPerPage) => resultsPerPage.results)
          ?.flatMap((d) => d)
      : []
  ) as JobListingItem[]

  return {
    fetchNextPage,
    hasNextPage,
    isError,
    isFetchingNextPage,
    isLoading,
    jobOffersList,
    refetch,
    total,
  }
}
